<app-mat-spinner-overlay *ngIf="showSpinner"> </app-mat-spinner-overlay>
<div class="mb-3">
  <div class="row m-0">
<div class="row m-0 col-md-12 p-0 mb-2">
  <div
    class="col-md-4 mb-2 my-2 bg-image hover-overlay ripple shadow-1-strong rounded"
    *ngFor="let item of dashboardData; let ind = index"
    (click)="getDetail(item.ShortName)"
  >
    <div
      class="card position-relative"
      style="height: fit-content; padding: 14px"
      [style.background]="gradientColors[ind]"
    >
      <div class="box-img">
        <img
          src="{{ iconname }}{{ item.IconImage }}"
          alt="img"
        />
      </div>
      <!--<div class="d-flex align-items-center pl-4 pr-4 justify-content-between box-content" style="width: 80%;">
            <span> {{item.IconName}} </span>
            <span> {{item.ItemCount}} </span>
        </div> -->
      <span
        class="badge badge-dark"
        style="
          font-size: 18px;
          position: absolute;
          padding: 6px 12px;
          border-radius: 10px;
          top: 10%;
          right: 4%;
        "
      >
        {{ item.ItemCount }}
      </span>
      <div class="cardText">
        <span style="font-size: 20px">{{ item.IconName }}</span>
      </div>
    </div>
  </div>
</div>
    <!--<div class="col-md-3 p-2 box" routerLink="/lms-dashboard/lms-loan-entry">-->
      <!-- loan-info -->
      <!--<div class="d-flex" style="border: 1px solid #DDDD;border-radius: 5px;">
        <div class="box-img">
          <img src="../../assets/images/app.png" alt="img" style="width: 100%;">
        </div>
        <div class="d-flex align-items-center pl-4 pr-4 justify-content-between box-content" style="width: 80%;">
          <span> Loan Entry </span>
        </div>
      </div>
    </div>-->
  </div>
</div>
